import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import "./CalendarUI.scss";
import ReactTooltip from "react-tooltip";
import dateFormat from "dateformat";

export default class CalendarUI extends React.Component {
  renderEventContent = (eventInfo) => {
    return (
      <>
        <div
          className="event-dot"
          style={{ border: `4px solid ${eventInfo.event.extendedProps.color}` }}
        ></div>
        <span data-tip={eventInfo.event.title} className="event-title">
          {eventInfo.event.title}
        </span>
      </>
    );
  };

  renderWeekContent = (weekInfo) => {
    let weekEndDate = new Date(weekInfo.date);
    weekEndDate.setDate(weekEndDate.getDate() + 6);
    return (
      <>
        <span className="week-text">{weekInfo.text}</span>
        <span className="week-description">
          {dateFormat(weekInfo.date, "dd mmm")} -{" "}
          {dateFormat(weekEndDate, "dd mmm")}
        </span>
      </>
    );
  };

  render() {
    return (
      <div
        className={`calendar-ui-wrapper ${
          this.props.weekNumbers ? " week-view" : ""
        }`}
      >
        <FullCalendar
          plugins={[dayGridPlugin]}
          initialView="dayGridMonth"
          fixedWeekCount={false}
          headerToolbar={false}
          themeSystem="bootstrap"
          events={this.props.calendarEvents}
          eventContent={this.renderEventContent}
          eventDidMount={(info) => ReactTooltip.rebuild()}
          dayMaxEventRows={true}
          weekNumbers={this.props.weekNumbers}
          weekNumberContent={this.renderWeekContent}
          weekText="Week "
          views={{
            dayGridMonth: {
              dayMaxEventRows: 3,
            },
          }}
          height="auto"
          eventClick={(e) => {
            ReactTooltip.hide();
            this.props.handleEventClick(e);
          }}
          ref={this.props.calendarRef}
        />
      </div>
    );
  }
}
